import type { RequireAtLeastOne } from 'types/helpers';

import setUrlParams from 'utils/set-url-params';

type Image = RequireAtLeastOne<
  {
    width: number;
    height: number;
    src?: string;
    url?: string;
    alt: string;
  },
  'src' | 'url'
>;

export const url = (data: Image): string => {
  let source = data.src ?? data.url;

  if (typeof source !== 'string') {
    throw new Error(`Expected "src" or "url" to be a string. Received ${typeof source}`);
  }

  if (source.startsWith('//')) {
    source = `https:${source}`;
  }

  const formattedURL = new URL(source, window.origin);
  setUrlParams(formattedURL, {
    crop: 'region',
    crop_height: '{cropheight}',
    crop_left: '{cropleft}',
    crop_top: '{croptop}',
    crop_width: '{cropwidth}',
    height: '{height}',
    width: '{width}',
  });

  return decodeURI(formattedURL.toString());
};

export const image = (data: Image, aspect?: number): string => `
  <img
    src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
    data-src="${url(data)}"
    data-aspectratio="${aspect ?? ''}"
    data-sizes="auto"
    data-focal-x="50"
    data-focal-y="50"
    data-max-width="${data.width}"
    data-max-height="${data.height}"
    alt="${data.alt ?? ''}"
    class="lazyload"
    decoding="async"
  >
`;

export const source = (data: Image, media: string, aspect?: number): string => `
  <source
    data-src="${url(data)}"
    data-aspectratio="${aspect ?? ''}"
    media="(min-width: ${media})"
  >
`;

export default {
  image,
  source,
  url,
};
